<template>
  <div class="field">
    <input
      :id="`switch-${key}`"
      ref="switch"
      type="checkbox"
      role="switch"
      class="switch is-rounded"
      :checked="value"
      :disabled="disabled"
      :aria-checked="value.toString()"
      :aria-describedby="description ? `switch-description-${key}` : null"
      :aria-labelledby="`switch-label-${key}`"
      @input="handleInput"
      @change="handleChange"
      @keydown="handleKeydown"
    >
    <label
      :id="`switch-label-${key}`"
      :for="`switch-${key}`"
      class="label"
      :aria-hidden="false"
    >
      <slot />
    </label>
    <div
      v-if="description"
      :id="`switch-description-${key}`"
      class="switch-description sr-only"
    >
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSwitch',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    key: Math.random().toString(36).substr(2, 9),
  }),
  mounted() {
    if (this.ariaLabel && this.$refs.switch) {
      this.$refs.switch.setAttribute('aria-label', this.ariaLabel);
    }
  },
  methods: {
    handleInput(event) {
      const { checked } = event.target;
      this.$emit('input', checked);
      this.announceChange(checked);
    },
    handleChange(event) {
      const { checked } = event.target;
      this.$emit('change', checked);
    },
    handleKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.$refs.switch.click();
      }
    },
    announceChange(newValue) {
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';

      const state = newValue ? 'ativado' : 'desativado';
      announcement.textContent = `Switch ${state}`;

      document.body.appendChild(announcement);

      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;

  .label {
    margin: 0;
    padding: {
      top: 0;
    }
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.switch:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

.switch:focus:not(:focus-visible) {
  outline: none;
}

.switch:focus-visible {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

.label:focus-within {
  outline: 2px solid #007bff;
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
